import React, { useEffect, useState } from "react";
import styles from "../styles/Partner2.module.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import brand from "../assets/brand.svg";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const CorporateJob = () => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleSubmitClick = () => {
    setShowConfirmation(true);
  };

  const handleDoneClick = () => {
    setShowConfirmation(false);
  };
  return (
    <div>
      <Header />
      <section className={styles.becomePartnerSection}>
        <div className={styles.becomePartnerContent}>
          <p className={styles.becomePartnerSubtitle}>ARIF JOB</p>
          <h2 className={styles.becomePartnerTitle}>Job Application Form</h2>
          <p>Corporate Affairs Management</p>
        </div>

        <div className={styles.becomePartnerGraphic}>
          <img src={brand} alt="brand" />
        </div>
      </section>
      <hr
        style={{
          border: "none",
          borderTop: "1px solid #ccc",
          margin: "40px 20px",
        }}
      />

      <section className={styles.tellUsSection}>
        <div className={styles.formGroup}>
          <label htmlFor="name">Full Name*:</label>
          <input type="text" id="name" placeholder="John doe" />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="email">Email Address:</label>
          <input type="email" id="email" placeholder="example@email.com" />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="phone">Phone Number:</label>
          <input type="tel" id="phone" placeholder="0912345445" />
        </div>
        <div className={styles.resume}>
          <lable>
            Resum(CV):
            <br />
            <br />
            <input type="file" name="RESUME" />
          </lable>
        </div>

        <button className={styles.newButton} onClick={handleSubmitClick}>
          Submit
        </button>
      </section>

      {showConfirmation && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#4CAF50",
                borderRadius: "50%",
                width: "80px",
                height: "80px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto 15px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="white"
                width="48"
                height="48"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
            </div>
            <p
              style={{
                color: "#8BC34A",
                fontWeight: "bold",
                marginBottom: "5px",
                fontSize: "0.9em",
              }}
            >
              APPLICATION SUMMITED
            </p>
            <h2 style={{ marginBottom: "10px" }}>Congratulation!</h2>
            <p style={{ color: "#777", marginBottom: "20px", fontSize: "1em" }}>
              Your application is summited . We will review your applications
              and get back with <br />
              you soon.
            </p>
            <button
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "1rem",
              }}
              onClick={handleDoneClick}
            >
              Done
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default CorporateJob;
